/** Shared paginator options used across the application. */
export const PAGINATOR_PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;

/** Default page size for paginated lists. */
export const DEFAULT_PAGINATOR_PAGE_SIZE = PAGINATOR_PAGE_SIZE_OPTIONS[0];
